(function() {
    'use strict';

    angular
        .module('gestioneAttiApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService', 'RESOURCE_PERMISSIONS','$translate', 'Atto'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService, RESOURCE_PERMISSIONS, $translate, Atto) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.nome = pagingParams.nome;
        vm.cognome = pagingParams.cognome;
        vm.email = pagingParams.email;
        vm.ruolo = pagingParams.ruolo;
        vm.RESOURCE_PERMISSIONS = RESOURCE_PERMISSIONS;
        vm.getAllAuthorities = getAllAuthorities;

        vm.loadAll();
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            Atto.defaultLegislatura({}, onSuccessDefLeg, onErrorDefLeg);
        }

        function onSuccessDefLeg(data) {
            vm.defaultLegislatura = data.legislatura;
            loadUsers();
        }
        function onErrorDefLeg(error) {
            vm.legislatura = 11;
            loadUsers();
        }

        function loadUsers() {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                nome: vm.nome,
                cognome: vm.cognome,
                email: vm.email,
                ruolo: vm.ruolo
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            if(error.status === 403){
                AlertService.error($translate.instant('error.access.external.forbidden'));
            } else {
                AlertService.error(error.data.message);
            }
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                nome: vm.nome,
                cognome: vm.cognome,
                email: vm.email,
                ruolo: vm.ruolo
            });
        }

        function getAllAuthorities(user) {
            var authorities = [];
            if(user && user.authorities) {
                angular.forEach(user.authorities, function(val, key){
                    authorities.push(val);
                });
            }
            if(user && user.legislaturaAuthorities) {
                angular.forEach(user.legislaturaAuthorities, function(legiAuth, key){
                    if(legiAuth.legislatura && legiAuth.legislatura.legislatura === vm.defaultLegislatura) {
                        angular.forEach(legiAuth.authorities, function(auth, key) {
                            authorities.push(auth.name);
                        });
                    }
                });
            }
            return authorities;
        }
    }
})();
